<template>
  <div>
    <div class="filter">
      <div class="row">
        <div class="column medium-3">
          <div class="search-box">
            <label class="field-label">{{ $t('transactions.filter.search') }}:</label>
            <div class="search">
              <div class="search-input-box">
                <input type="text" v-model="searchInput" :disabled="loading"
                  v-on:keypress.enter="search" :class="{'has-error':!!hasError.searchMsg}"
                  v-on:blur="blurSearch" ref="search"/>
                  <transition name="fade">
                    <i class="far fa-times-circle fa-lg" @click="clearSearch"
                      v-show="searchInput.length > 0"></i>
                  </transition>
              </div>
              <button :class="{'button xsmall success':true, 'disabled':loading}"
                @click="search">
                <i class="fas fa-search fa-lg"></i>
              </button>
            </div>

            <transition name="slide-up">
              <div class="error-msg" v-show="!!hasError.searchMsg">{{ hasError.searchMsg }}</div>
            </transition>
          </div>
        </div>

        <div class="column medium-2">
          <label class="field-label">{{ $t('transactions.filter.status') }}:</label>
          <select v-model="status" :disabled="loading">
            <option value="">{{ $t('transactions.filter.all') }}</option>
            <option value="Declined">{{ $t('transactions.filter.declined') }}</option>
            <option value="Cancelled">{{ $t('transactions.filter.cancelled') }}</option>
            <option value="Purchased">{{ $t('transactions.filter.purchased') }}</option>
            <option value="Promo">{{ $t('transactions.filter.promo') }}</option>
            <option value="Authorized">{{ $t('transactions.filter.authorized') }}</option>
            <option value="No Show">{{ $t('transactions.filter.noShow') }}</option>
            <option value="Completed">{{ $t('transactions.filter.completed') }}</option>
            <option value="Refund">{{ $t('transactions.filter.refund') }}</option>
            <option value="Edited">{{ $t('transactions.filter.edited') }}</option>
          </select>
        </div>

        <div class="column medium-5">
          <div class="date-range">
            <label class="field-label">{{ $t('transactions.filter.dateRange') }}:</label>
            <select v-model="dateType" :disabled="loading">
              <option value="all">{{ $t('transactions.filter.all') }}</option>
              <option value="custom">{{ $t('transactions.filter.custom') }}</option>
              <option value="withinDay">{{ $t('transactions.filter.withinDay') }}</option>
              <option value="monthToDate">{{ $t('transactions.filter.monthToDate') }}</option>
              <option value="lastMonth">{{ $t('transactions.filter.lastMonth') }}</option>
              <option value="lastWeek">{{ $t('transactions.filter.lastWeek') }}</option>
              <option value="last2Week">{{ $t('transactions.filter.last2Week') }}</option>
              <option value="last30Days">{{ $t('transactions.filter.last30Days') }}</option>
              <option value="last60Days">{{ $t('transactions.filter.last60Days') }}</option>
              <option value="last90Days">{{ $t('transactions.filter.last90Days') }}</option>
            </select>

            <div class="datepicker-div">
              <div class="datepicker-box">
                <datepicker :format="calendarFormat"
                  :class="{'datepicker inline':true, 'has-error':false}"
                  v-model="date.from" ref="datepickerFrom"
                  v-on:input="updateFromTo('from')" :disabled-picker="loading"
                  :input-class="{'datepicker-empty':hasError.from}"
                  :placeholder="$t('transactions.filter.from')"></datepicker>
              </div>

              <div class="datepicker-box">
                <datepicker :format="calendarFormat" class="datepicker inline"
                  v-model="date.to" ref="datepickerTo"
                  v-on:input="updateFromTo('to')" :disabled-picker="loading"
                  :input-class="{'datepicker-empty':hasError.to}"
                  :placeholder="$t('transactions.filter.to')"></datepicker>
              </div>
            </div>


            <transition name="slide-up">
              <div class="error-msg" v-show="!!hasError.fromToMsg">
                {{ hasError.fromToMsg }}
              </div>
            </transition>
          </div>
        </div>

        <div class="column medium-2">
          <div class="export">
            <!-- <button class="button cta small" @click="invoice.showModal = true">Print Invoice</button> -->
            <a :class="{'button cta success small':true, 'disabled':!transactions.length || loading}"
              @click="exportTrx">{{ $t('transactions.filter.export') }}</a>
          </div>
        </div>

      </div>
    </div>

    <div class="clearfix"></div>

    <div :class="{'modal':true, 'show':invoice.showModal}">
      <div class="bg-overlay" @click="closeInvoice"></div>
      <div class="modal-content invoice-box">
        <div class="header">Create Invoice</div>

        <div class="row">
          <div class="column medium-6 padding-R-s">
            <div class="data-field">
              <div class="label">Date Coverage From</div>
              <datepicker :format="calendarFormat"
                :class="{'datepicker inline':true, 'has-error':!!invoice.error.dateFrom}"
                v-model="invoice.dateFrom" :disabled-picker="exportLoading"
                :input-class="{'datepicker-empty':invoice.error.dateFrom}"
                ></datepicker>
              <span class="error-msg">{{ invoice.error.dateFrom }}</span>
            </div>
          </div>

          <div class="column medium-6 padding-L-s">
            <div class="data-field">
              <div class="label">Date Coverage To</div>
              <datepicker :format="calendarFormat"
                :class="{'datepicker inline':true, 'has-error':!!invoice.error.dateTo}"
                v-model="invoice.dateTo" :disabled-picker="exportLoading"
                :input-class="{'datepicker-empty':invoice.error.dateTo}"
                ></datepicker>
              <span class="error-msg">{{ invoice.error.dateTo }}</span>
            </div>
          </div>

          <div class="column medium-12">
            <div class="data-field">
              <div class="label">Payment Due Date</div>
              <datepicker :format="calendarFormat"
                :class="{'datepicker inline':true, 'has-error':!!invoice.error.dueDate}"
                v-model="invoice.dueDate" :disabled-picker="exportLoading"
                :input-class="{'datepicker-empty':invoice.error.dueDate}"
                :disabled="disabledDueDate"></datepicker>
              <span class="error-msg">{{ invoice.error.dueDate }}</span>
            </div>
          </div>
        </div>

        <div class="has-error" v-show="invoice.showZeroResults">Empty result.</div>
        <button :class="{'button cta block small':true, 'disabled':invoiceLoading}" @click="createInvoice">
          <span v-if="!invoiceLoading">Create</span>
          <span v-else>Loading...</span>
        </button>
        <span class="close" @click="closeInvoice">Close</span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import datepicker from 'vuejs-datepicker'
import CsvExport from 'csvexport'
import ApiTransactions from '@/modules/api/corporate/transactions'

const exporter = CsvExport.create({
  filename: "export.csv",
  columns: [
    'Date', 'Booking Time', 'Pickup Time', 'Service Area', 'Prov ID',
    'Prov License', 'Company', 'RSVP ID', 'Consumer Notes', 'Invoice ID', 'Service Type',
    'First Name', 'Last Name', 'Credit Card', 'Email', 'Mobile', 'Source',
    'Final Offer', 'Charge Amount', 'Refunded Amount', 'Promo Used', 'Driver Payment',
    'Bonus', 'Cancel Fees', 'Status', 'Pickup Location', 'Dropoff Location'
  ]
});

// const exporter = CsvExport.create({
//   filename: 'export.csv',
//   columns: [
//     'Charged Date', 'Customer', 'Card Owner', 'RSVP ID', 'Invoice ID',
//     'TRX Type', 'Charged Amount', 'Refunded Amount'
//   ]
// })

export default {
  name: 'transaction-filter',
  components: { datepicker },
  data () {
    return {
      searchInput: '',
      blurDelay: '',
      from: '',
      to: '',
      hasError: {
        searchMsg: '',
        from: false,
        to: false,
        fromToMsg: ''
      },
      sort: {
        active: 'created',
        isDesc: true
      },
      invoice: {
        showModal: false,
        dueDate: moment().format(),
        dateFrom: '',
        dateTo: '',
        error: {
          dueDate: '',
          dateFrom: '',
          dateTo: ''
        },
        showZeroResults: false
      },
      today: moment(),
      pdf: {
        data: {},
      },
      exportLoading: false
    }
  },
  computed: {
    conId () { return this.$store.state.corporate.profile.info.consId },
    status: {
      get: function () { return this.$store.state.corporate.transactions.status },
      set: function (value) {
        this.$store.commit('corporate/setTrxStatus', value)
        if ((this.date.from === '' || this.date.to === '') && this.dateType !== 'all') {
          this.hasError.from = this.date.from === ''
          this.hasError.to = this.date.to === ''
          return
        }
        this.getTransactions()
      }
    },
    dateType: {
      get: function () { return this.$store.state.corporate.transactions.date },
      set: function (value) {
        this.$store.commit('corporate/setTrxDate', value)

        let from = ''
        let to = value === 'all' ? '' : moment().format('MM/DD/YYYY')
        if (value === 'withinDay') {
          from = moment().format('MM/DD/YYYY')
        }
        if (value === 'monthToDate') {
          from = moment(moment().format('MM') + '/1/' + moment().format('YYYY'), 'MM/DD/YYYY').format('MM/DD/YYYY')
        }
        if (value === 'lastMonth') {
          let lastMonth = moment().subtract(1, 'months')
          from = lastMonth.format('MM/01/YYYY')
          to = lastMonth.endOf('month').format('MM/DD/YYYY')
        }
        if (value === 'lastWeek') {
          let subtractDays = 0
          let currentDate = parseInt(moment().format('E'))
          if (currentDate !== 7) { subtractDays = currentDate }

          from = moment().subtract(subtractDays + 6, 'days').format('MM/DD/YYYY')
          to = moment().subtract(subtractDays, 'days').format('MM/DD/YYYY')
        }
        if (value === 'last2Week') {
          let subtractDays = 0
          let currentDate = parseInt(moment().format('E'))
          if (currentDate !== 7) { subtractDays = currentDate }
          from = moment().subtract(subtractDays + 13, 'days').format('MM/DD/YYYY')
          to = moment().subtract(subtractDays, 'days').format('MM/DD/YYYY')
        }
        if (value === 'last30Days') {
          from = moment().subtract(30, 'days').format('MM/DD/YYYY')
        }
        if (value === 'last60Days') {
          from = moment().subtract(60, 'days').format('MM/DD/YYYY')
        }
        if (value === 'last90Days') {
          from = moment().subtract(90, 'days').format('MM/DD/YYYY')
        }

        if (value !== 'custom') {
          this.hasError = { searchMsg: '', from: false, to: false, fromToMsg: '' }
          this.$store.commit('corporate/setTrxDateFrom', from)
          this.$store.commit('corporate/setTrxDateTo', to)

          if (value === 'all' && this.searchInput === '') {
            this.hasError.searchMsg = this.$t('transactions.filter.searchEmpty')
            let self = this
            self.$nextTick(() => { self.$refs.search.focus() })
            return
          }

          this.getTransactions()
        }
      }
    },
    date () {
      let filter = this.$store.state.corporate.transactions
      return {
        from: filter.dateFrom,
        to: filter.dateTo
      }
    },
    transactions () { return this.$store.state.corporate.transactions.list },
    loading () { return this.$store.state.corporate.transactions.loading },
    disabledDueDate () {
      if (this.today.format('MM') === '01') {
        return {
          to: new Date(
            this.today.subtract(1, 'months').format('YYYY'),
            this.today.format('MM'),
            this.today.format('DD')
          )
        }
      }

      return {
        to: new Date(
          this.today.format('YYYY'),
          this.today.subtract(1, 'months').format('MM'),
          this.today.format('DD')
        )
      }
    },
    invoiceLoading () { return this.$store.state.corporate.invoice.loading }
  },
  methods: {
    init () {
      let self = this
      self.$store.commit('corporate/resetTrxFilters')
      self.$store.commit('corporate/setTrxDateFrom', moment().format('MM/DD/YYYY'))
      self.$store.commit('corporate/setTrxDateTo', moment().format('MM/DD/YYYY'))

      self.getTransactions()
    },
    search () {
      this.searchInput = this.searchInput.trim()
      this.$store.commit('corporate/setTrxSearch', this.searchInput)

      if (this.searchInput === '' && this.dateType === 'all') {
        this.hasError.searchMsg = this.$t('transactions.filter.searchEmpty')
        return
      }
      this.hasError.searchMsg = ''

      if ((this.date.from === '' || this.date.to === '') && this.dateType !== 'all') {
        this.hasError.from = this.date.from === ''
        this.hasError.to = this.date.to === ''
        return
      }

      if (this.searchInput !== '') {
        this.$store.commit('corporate/setTrxDate', 'all')
        this.$store.commit('corporate/setTrxDateFrom', '')
        this.$store.commit('corporate/setTrxDateTo', '')
      }
      this.getTransactions()
    },
    blurSearch () {
      let self = this
      if (self.$store.state.corporate.transactions.search === self.searchInput.trim()) {
        return
      }

      self.blurDelay = setTimeout(function () {
        self.search()
      }, 500)
    },
    clearSearch () {
      if (this.blurDelay) { clearTimeout(this.blurDelay) }

      if (this.loading) { return }

      this.searchInput = ''
      this.$store.commit('corporate/setTrxSearch', this.searchInput)
      this.dateType = 'withinDay'
    },
    calendarFormat (date) { return moment(date).format('MM/DD/YYYY'); },
    updateFromTo (fromTo) {
      this.$store.commit('corporate/setTrxDate', 'custom')

      let format = 'MM/DD/YYYY'
      let from = ''
      let to = ''

      if (fromTo === 'from') {
        this.hasError.from = false
        from = moment(this.date.from)
        this.$store.commit('corporate/setTrxDateFrom', from.format(format))
        if (this.date.to) { to = moment(this.date.to, format) }
      } else {
        this.hasError.to = false
        to = moment(this.date.to)
        this.$store.commit('corporate/setTrxDateTo', to.format(format))
        if (this.date.from) { from = moment(this.date.from, format) }
      }

      this.hasError = { searchMsg: '', from: false, to: false, fromToMsg: '' }

      if (this.date.from === '' || this.date.to === '') {
        if (fromTo === 'from') { this.hasError.to = true }
        else { this.hasError.from = true }
        this.hasError.fromToMsg = this.$t('transactions.filter.emptyDate')
        return
      }
      if (from.format('x') > to.format('x')) {
        this.hasError.from = true
        this.hasError.to = true
        this.hasError.fromToMsg = this.$t('transactions.filter.invalidDateRange')
        return
      }
      this.getTransactions()
    },
    getTransactions () {
      let self = this
      if (self.loading || !self.conId) { return }

      this.$store.commit('corporate/resetTransactions')
      this.$store.commit('corporate/setTrxCurrentPage', 1)

      self.$store.commit('corporate/setTrxLoading', true)
      ApiTransactions.getTransactions(self, self.conId, function () {
        self.$store.commit('corporate/setTrxLoading', false)
      })
    },
    exportTrx () {
      let self = this

      // let transactions = self.$store.state.corporate.transactions
      // let pickupSince = moment(transactions.dateFrom, 'MM/DD/YYYY').format('YYYY-MM-DD 00:00')
      // let pickupUntil = moment(transactions.dateTo, 'MM/DD/YYYY').format('YYYY-MM-DD 23:59')
      // if (transactions.date === 'all') {
      //   pickupSince = '2010-01-01 00:00'
      //   pickupUntil = moment().add(10, 'years').format('YYYY-MM-DD 23:59')
      // }

      // self.$sdk.get('/reports/trx/list', {
      //   token: this.$store.state.session.sessionToken,
      //   since: pickupSince,
      //   until: pickupUntil,
      //   originals: 1,
      //   tiptrx: 1,
      //   cancelfeetrx: 1,
      //   consId: self.conId
      // }, res => {
      //   if (res.list) {
      //     let trx = []
      //     res.list.forEach(list => {
      //       let charged = list.trxType !== 'Refund' ? self.covertNumber(parseFloat(list.chargedAmount).toFixed(2)) : '-'
      //       let refund = list.trxType === 'Refund' ? self.covertNumber(parseFloat(list.chargedAmount).toFixed(2)) : '-'
      //       trx.push({
      //         'Charged Date': moment(list.created, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY  HH:mm'),
      //         'Customer': list.customer,
      //         'Card Owner': list.cardOwner,
      //         'RSVP ID': list.rsvpId,
      //         'Invoice ID': list.invoiceID,
      //         'TRX Type': list.trxType,
      //         'Charged Amount': charged,
      //         'Refunded Amount': refund
      //       })
      //     })
      //     exporter.downloadCsv(trx)
      //   }
      // })

      ApiTransactions.exportTransactions(self, self.conId, function (res) {
        if (!res.error) {
          exporter.downloadCsv(res)
        }
      })
    },
    covertNumber (value) { return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") },
    closeInvoice () {
      this.invoice.showModal = false
      this.invoice.showZeroResults = false
    },
    createInvoice () {
      if (this.invoiceLoading) { return }

      let hasError = false
      for (let field in this.invoice.error) {
        if (this.invoice[field] === '') {
          this.invoice.error[field] = 'This field cannot be empty.'
          hasError = true
        }
      }

      if (hasError) { return }

      let from = moment(this.invoice.dateFrom)
      let to = moment(this.invoice.dateTo)
      if (from.format('x') > to.format('x')) {
        this.invoice.error.dateFrom = 'Invalid date range'
        this.invoice.error.dateTo = 'Invalid date range'
        return
      }

      this.$store.commit('corporate/setInvoiceDateFrom', moment(this.invoice.dateFrom).format('MM/DD/YYYY'))
      this.$store.commit('corporate/setInvoiceDateTo', moment(this.invoice.dateTo).format('MM/DD/YYYY'))
      this.$store.commit('corporate/setInvoiceDueDate', moment(this.invoice.dueDate).format('MM/DD/YYYY'))

      this.invoice.showZeroResults = false
      if (this.$refs.invoice.buildTable()) {
        this.$refs.invoice.buildTable()
      }
    },
    zeroResults () { this.invoice.showZeroResults = true }
  },
  watch: {
    conId: function (value) { this.init() }
  },
  mounted () {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.clearfix{ clear: both; }

.field-label{
  font-size: 13px;
  color: #777;
  line-height: 1;
  display: block;
  margin-bottom: 4px;
}

.filter{
  padding-bottom: 30px;

  .row{
    max-width: inherit;
    width: 100%;
    margin: 0;
  }

  .column:not(:last-child){
    padding-right: 20px;
  }

  .status{
    display: inline-block;
    padding: 20px 15px;
    width: 150px;
  }
}

.search-box{
  display: block;
  position: relative;

  .error-msg{
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    padding: 2px 5px;
    font-size: 12px;
    text-align: center;
    background: #ff6115;
    color: #fff;
    transform-origin: top center;
  }
}
.search{
  box-sizing: border-box;
  display: flex;
  width: 100%;

  .search-input-box{
    width: 100%;
    position: relative;

    input{
      display: inline-block;
      vertical-align: middle;
      margin-top: 0;
      border-radius: 3px 0 0 2px;
      padding-right: 30px;

      &.has-error{ border-color:#f33a27; }
    }
    i{
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 5px;
      color: #d92626;
      cursor: pointer;
    }
  }
  button{
    display: inline-block;
    vertical-align: middle;
    line-height: 1;
    border-radius: 0 3px 2px 0;
    padding: 0 20px;
  }
}

select{
  padding: 10px;
  height: 46px;
  outline: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: url('/assets/img/dropdown-arrow.png');
  background-repeat: no-repeat;
  background-position: right 50%;

  &[disabled]{ background-color: #ebebe4; }
}

.date-range{
  position: relative;
  display: inline-block;

  select{
    width: 150px;
    margin-right: 5px;
  }
  .error-msg{
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    padding: 2px 5px;
    font-size: 12px;
    text-align: center;
    background: #ff6115;
    color: #fff;
    transform-origin: top center;
  }
  
  .datepicker-div {
    display: inline-block;
  }
}
.datepicker-box{
  display: inline-block;
  width: 110px;
}

.export{
  text-align: right;
  padding: 15px 10px 0;
  flex: 0 130px;
}

.modal{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0, .5);
  display: none;
  z-index: 12;

  .bg-overlay{
    position: absolute;
    top:0;
    left:0;
    width: 100%;
    height: 100%;
  }
  .modal-content{
    position: absolute;
    top: 50%;
    left: 50%;
    padding: 15px 25px;
    background: #fff;
    text-align: center;
    border-radius: 6px;
    margin-left: -200px;
    margin-top: -108px;
    box-shadow: 1px 1px 5px 2px rgba(0,0,0, .3);
    display: none;

    &.upload{
      top: 50%;
      width: 900px;
      height: 550px;
      margin-top: -265px;
      margin-left: -450px;

    }
  }
  &.show{
    display: block;

    .modal-content{
      display: block;
      -webkit-animation: slide-down .3s ease-out;
      -moz-animation: slide-down .3s ease-out;
    }
  }
  .header{
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 15px;
    color: #606060;
  }
  .has-error{
    color: #f00;
    background: #ffefef;
    border: 1px solid #f00;
    margin-bottom: 10px;
    border-radius: 2px;
    font-size: 15px;
    line-height: 1.6;
  }
  .close{
    display: block;
    margin-top: 5px;
    font-size: 14px;
    color: #999;
    cursor: pointer;

    &:hover{
      text-decoration: underline;
      color: #555;
    }
  }
}

.data-field{
  padding: 5px;
  position: relative;

  .label{
    color: #888;
    font-weight: 600;
    font-size: 11px;
    text-transform: uppercase;
    line-height: 130%;

    &.has-error{ color: #f20d0d; }
  }
  .input{
    margin: 1px 0 0;
    padding: 5px;
    font-size: 14px;
    color: #333;
    line-height: inherit;
    transition: all .35s ease;

    &.has-error{ border-color: #f20d0d; }
    &:disabled{ background: #eee; }
  }
  .error-msg{
    font-size: 11px;
    line-height: 1.6;
    color: #f20d0d;
    font-style: italic;
    display: block;
  }
}

.invoice-box{
  width: 500px;

  .row{ margin-bottom: 20px; }
  .data-field{
    margin-bottom: 10px;
    text-align: left;
  }
}

.padding-R-s{ padding-right: 5px; }
.padding-L-s{ padding-left: 5px; }
.margin-B-m{ margin-bottom: 10px; }

.slide-up-enter-active, .slide-up-leave-active { transition: all .3s ease; }
.slide-up-enter, .slide-up-leave-to {
  transform: rotateX(-90deg);
  opacity: 0;
}

@media only screen and (max-width: 430px) {
  .filter {
    .column:not(:last-child) {
      padding-right: 0;
      margin-bottom: 10px;
    }
  }

  .export {
    text-align: center;
    padding: 0;
    a {
      width: 100%;
    }
  }

  .date-range {
    select {
      width: 100%;
    }
    .datepicker-div {
      margin-top: 5px;
      display: flex;
      gap: 10px;
      .datepicker-box {
        width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Corporate/TransactionFilter.vue